import { ReactNode, useEffect } from "react";
import { useIsInstalledOnShop } from "../hooks/api/use-is-installed-on-shop";
import { useInstallOnShop } from "../hooks/api/use-install-on-shop";
import { InstallationContext } from "../contexts/InstallationContext";

export const InstallationProvider = ({ children }: { children: ReactNode }) => {
  const { data: installedRes, isPending: readPending, isError: isReadError } = useIsInstalledOnShop();
  const { isPending: writePending, mutate, isError: isWriteError } = useInstallOnShop();

  const isInstalled = installedRes?.isInstalled;

  useEffect(() => {
    if (isInstalled === false && !readPending && !writePending && !isWriteError) {
      mutate();
    }
  }, [isInstalled, isWriteError, mutate, readPending, writePending]);

  const isLoading = readPending || (isInstalled === false && !isWriteError);
  const isError = isReadError || isWriteError;

  return (
    <InstallationContext.Provider value={{ isInstalled, plan: installedRes?.plan, isLoading, isError }}>
      {children}
    </InstallationContext.Provider>
  );
};
